import React from 'react'
import { Button, Modal, Spin } from 'antd'

interface Props {
  // сколько процентов файла уже отправлено; null — окно закрыто
  progress: number | null
  onCancel: () => void
}

export const BannerSavingModal = ({ progress, onCancel }: Props) => (
  <Modal
    open={progress !== null}
    closable={false}
    maskClosable={false}
    keyboard={false}
    centered
    width={380}
    // поверх окна баннера, даже если оно открыто позже
    zIndex={1100}
    footer={<Button onClick={onCancel}>Отмена</Button>}
  >
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 16,
        paddingTop: 16,
        textAlign: 'center'
      }}
    >
      <Spin size='large' />
      <div style={{ fontWeight: 600 }}>
        {progress !== null && progress < 100 ? `Загружаем видео — ${progress} %` : 'Делаем две версии видео'}
      </div>
      <div>Это займёт несколько минут. Не закрывайте страницу, иначе баннер не сохранится.</div>
    </div>
  </Modal>
)
